//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as CrossMediumSVG } from './assets/medium/cross.inline.svg'

interface CrossMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const CrossMediumIcon: React.FC<
  React.PropsWithChildren<CrossMediumIconProps>
> = forwardRef<CrossMediumIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={CrossMediumSVG}
      sx={sx}
      color={color}
    />
  )
)
